import { Stage } from "./consants";
import {
  getAuthURLFromDomain,
  getBPURLFromDomain,
  getStageFromDomain,
  isDomainDev,
  isDomainProd,
} from "./shared";

export const getCurrentDomain = (): string => {
  if (typeof window !== "undefined") {
    return window.location.hostname;
  }
  return "aws.com";
};

export const isDevClient = (): boolean => {
  return isDomainDev(getCurrentDomain());
};

export const isProdClient = (): boolean => {
  return isDomainProd(getCurrentDomain());
};

export const getStageClient = (): Stage => {
  return getStageFromDomain(getCurrentDomain());
};

export const getAuthURLClient = (): string => {
  return getAuthURLFromDomain(getCurrentDomain());
};

export const getBPURLClient = (): string => {
  return getBPURLFromDomain(getCurrentDomain());
};
